// Kept separate from index.tsx so callers that only need the dialog type string (e.g. to
// dispatch createDialog) don't pull in the dialog component itself - see modalRegistrations.ts's
// ImportModalComponent registration, which relies on this to lazy-load the drawer's SPayeeField
// dependency chain.
export const DIALOG_TYPE_REVIEW_RENAME_PAYEE = 'REVIEW_RENAME_PAYEE_PROPOSALS';
